import * as React from 'react';
import { connect } from 'react-redux';
import { FestivalOverviewAppState } from '../classes/redux-states';

interface StateToProps {
    rightWYSIWYG: string;
    leftWYSIWYG: string;
}

export class FestivalInfoComponent extends React.Component<StateToProps, null> {
    constructor(props: StateToProps) {
        super(props);
    }

    render() {
        if (this.props.leftWYSIWYG !== null || this.props.rightWYSIWYG !== null) {
            return (

                <div className="overview-block">
                    <div className="overview-block-container">
                        <div className="overview-block-item">
                            <div className="rich-text overview-block-item-text" dangerouslySetInnerHTML={{ __html: this.props.leftWYSIWYG }}></div>
                        </div>
                        <div className="overview-block-item">
                            <div className="rich-text overview-block-item-text" dangerouslySetInnerHTML={{ __html: this.props.rightWYSIWYG }}></div>
                        </div>
                    </div>
                </div>
            );
        }
        else
            return null;

    }
}

function mapStateToProps(state: FestivalOverviewAppState): StateToProps {
    return {
        leftWYSIWYG: state.festivalOverviewSettingsModel.leftWYSIWYG,
        rightWYSIWYG: state.festivalOverviewSettingsModel.rightWYSIWYG
    }
}

export default connect(mapStateToProps, null)(FestivalInfoComponent);